import { render, staticRenderFns } from "./CommissionPieChart.vue?vue&type=template&id=198b8b54"
import script from "./CommissionPieChart.vue?vue&type=script&lang=js"
export * from "./CommissionPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports